module.exports = __webpack_public_path__ + "img/option2.fe906a65.png";